import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../../shared";
import { PreferenceRequestModel } from "./PreferenceRequestModel";
import { SendMailRequest } from "./SendMailRequest";

@Injectable()
export class DataService_AdvancedPreferences {
	constructor(private httpclientService: HttpclientService) {}

	EnableCAASSNotify(SchoolIDs: number[]) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/EnableCAASSNotify";

		var promise$ = this.httpclientService.post(url, SchoolIDs);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DisableCAASSNotify(SchoolIDs: number[]) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/DisableCAASSNotify";

		var promise$ = this.httpclientService.post(url, SchoolIDs);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	NotifySchoolInfoSelectList() {
		var postResult$ = new Subject();
		var url = "SchoolSettings/NotifySchoolInfoSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SendMail(parms: SendMailRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/SendMail";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SendNotification(parms: SendMailRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/SendNotification";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadAllSchools() {
		var postResult$ = new Subject();
		var url = "SchoolSettings/LoadAllSchools?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddPreference(parm: PreferenceRequestModel) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/AddPreference";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BaseURLSelect() {
		var postResult$ = new Subject();
		var url = "SchoolSettings/BaseURLSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
